import httpClient from "./httpClient";

const base = "/settings/teacher-sections";

export function listTeacherSections() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function createTeacherSection(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function updateTeacherSection(id, payload) {
  return httpClient.put(`${base}/${id}`, payload).then((res) => res.data.data);
}

export function deleteTeacherSection(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}
